import firebase from "@/firebase";

export default {
  namespaced: true,
  state: {
    profile: {},
    profiles: []
  },
  getters: {
    getProfile(state) {
      return state.profile;
    },
    getProfiles(state) {
      return state.profiles;
    }
  },
  mutations: {
    addProfile(state, data) {
      state.profiles.push(data);
    },
    removeProfile(state, id) {
      const i = state.profiles.findIndex(a => a.id === id);
      state.profiles.splice(i, 1);
    },
    setProfile(state, data) {
      const i = state.profiles.findIndex(a => a.id === data.id);
      state.profiles[i] = data;
      state.profile = data;
    },
    setProfiles(state, data) {
      state.profiles = data;
    }
  },
  actions: {
    async initProfile(state, id) {
      const profile = await firebase.db
        .collection("profiles")
        .doc(id)
        .get();
      state.commit("setProfile", profile.data());
    },
    async listProfiles(state) {
      const refs = await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("profiles")
        .get();

      let profiles = [];
      refs.forEach(ref => profiles.push(ref.data()));
      profiles = profiles.map(async ref => {
        return await firebase.db
          .collection("profiles")
          .doc(ref.id)
          .get();
      });
      profiles = await Promise.all(profiles);

      let data = [];
      profiles.forEach(profile => {
        if (profile.data()) {
          data.push(profile.data());
        }
      });
      state.commit("setProfiles", data);
    },
    async createProfile(state, data) {
      const fireData = {
        firstName: data.firstName,
        lastName: data.lastName,
        dateOfBirth: data.dateOfBirth
      };

      const profile = await firebase.db.collection("profiles").add(fireData);

      await firebase.db
        .collection("users")
        .doc(firebase.auth.currentUser.uid)
        .collection("profiles")
        .doc(profile.id)
        .set({ id: profile.id });

      if (data.picture) {
        await state.dispatch("updatePicture", {
          file: data.picture,
          id: profile.id
        });
      }

      state.commit("addProfile", data);
      return profile.id;
    },
    async deleteProfile(state, id) {
      await firebase.db
        .collection("profiles")
        .doc(id)
        .delete();
      state.commit("removeProfile", id);
    },
    async shareProfile(state, { id, email }) {
      const users = await firebase.db
        .collection("users")
        .where("email", "==", email)
        .get();
      if (users.empty) {
        return false;
      }
      const user = users.docs[0].data();
      await firebase.db
        .collection("users")
        .doc(user.id)
        .collection("profiles")
        .add({ id });
      return user;
    },
    async updatePicture(state, { file, id }) {
      const path = `${id}/images/${file.name}`;
      const ref = firebase.storage.ref().child(path);
      await ref.put(file);
      const picture = await ref.getDownloadURL();
      await state.dispatch("updateProfile", { id, picture });
    },
    async updateVideo(state, { file, id }) {
      const path = `${id}/videos/${file.name}`;
      const ref = firebase.storage.ref().child(path);
      await ref.put(file);
      const video = await ref.getDownloadURL();
      await state.dispatch("updateProfile", { id, video });
    },
    async updateProfile(state, data) {
      await firebase.db
        .collection("profiles")
        .doc(data.id)
        .update(data);
      const profile = await firebase.db
        .collection("profiles")
        .doc(data.id)
        .get();
      state.commit("setProfile", profile.data());
    }
  }
};
